import { Events } from "phaser";

export const EventBus = new Events.EventEmitter();
